module.exports = __webpack_public_path__ + "img/zhyl.87e64c30.png";